import { Flex } from '@driftt/dds'
import React, { useState } from 'react'

import { PersonaCard } from 'components/AIConfiguration/LeadQualification/PersonaCard'
import useContactAttributes from 'hooks/useContactAttributes'
import { useGPTQualificationAttributes } from 'hooks/useGPTQualificationAttributes'

import { isEmptyOrNil } from '../../../utils'
import { ConfigLoader } from './ConfigLoader'
import { EmptyStateContainer } from './EmptyStateContainer'

const LeadQualification = () => {
  const { data: contactAttributes = [], isLoading } = useContactAttributes()
  const { qualificationPersona } = useGPTQualificationAttributes({
    shouldFetchAttributes: true,
  })
  const [shouldAddNewPersona, setShouldAddNewPersona] = useState(false)

  const handlePersonaSave = () => {
    setShouldAddNewPersona(false)
  }

  const hasAttributesConfg =
    !isEmptyOrNil(qualificationPersona) || shouldAddNewPersona

  if (isLoading) {
    return <ConfigLoader />
  }

  if (!hasAttributesConfg) {
    return (
      <EmptyStateContainer
        onCreatePersona={() => setShouldAddNewPersona(true)}
      />
    )
  }

  return (
    <Flex direction="column" gap={3}>
      {qualificationPersona && (
        <PersonaCard
          key={qualificationPersona?.id}
          persona={qualificationPersona}
          contactAttributes={contactAttributes}
        />
      )}
      {shouldAddNewPersona ? (
        <PersonaCard
          onPersonaSave={handlePersonaSave}
          contactAttributes={contactAttributes}
        />
      ) : null}
    </Flex>
  )
}

export default LeadQualification
